import { defineStore } from 'pinia'
import { ref } from 'vue'

/**
 * @description 系统信息模块
 */
export const useSystem = defineStore('system', () => {
  const LAYOUTS = ['defaultLayout', 'newLayout'] as const

  const currentLayout = ref('newLayout')

  const isCollapse = ref(false)
  // 是否二级菜单
  const isSecondMenu = ref(false)

  /**
   * 初始化布局配置
   * @param uiVersion 用户界面版本号，默认为2
   */
  function initLayout(uiVersion = 2) {
    const LAYOUTS = ['defaultLayout', 'newLayout'] as const
    // 获取用户界面版（避免索引越界）
    const layoutIndex = Math.max(0, Math.min(uiVersion - 1, LAYOUTS.length - 1))
    currentLayout.value = LAYOUTS[layoutIndex]
  }
  /**
   * @description 设置当前布局
   * @param layout 要设置的布局名称
   */
  function setCurrentLayout(layout: (typeof LAYOUTS)[number]) {
    // 验证布局是否有效
    if (!LAYOUTS.includes(layout)) {
      console.warn(`Invalid layout: ${layout}. Using default layout.`)
      currentLayout.value = 'newLayout'
      return
    }
    currentLayout.value = layout
  }

  /**
   * 设置侧边栏折叠状态
   * @param collapse 是否折叠
   */
  function setIsCollapse(collapse: boolean) {
    isCollapse.value = collapse
  }

  return {
    isSecondMenu,
    isCollapse,
    initLayout,
    setIsCollapse,
    currentLayout,
    setCurrentLayout
  }
})
